module.exports = {"pageTitleText":"Probes","createText":"新增","hostname":"HostName","serviceIP":"ServiceIP","description":"叙述","status":"状态","sections":{"essential":"基础"}}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-CN/probesetting.json
// module id = BX2d
// module chunks = 3